/* eslint-disable jira/filename-case */
/* oxlint-disable guard-for-in */
import type { ComponentType, ReactNode } from 'react';
import type { ActionThunk, BoundActions, Selector, Store } from '../types.tsx';
import { createHook } from './hook.tsx';

export type RenderPropComponent<TState, TActions> = (state: TState, actions: TActions) => ReactNode;

export type SubscriberComponent<TState, TActions, TProps = undefined> = ComponentType<
	{
		children: RenderPropComponent<TState, TActions>;
	} & TProps
>;

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
function hasAdditionalProps(props: any) {
	for (const i in props) return true;
	return false;
}

export function createSubscriber<
	TState,
	TActions extends Record<string, ActionThunk<TState, TActions>>,
	TSelectedState = TState,
	TSubscriberProps = unknown,
>(
	store: Store<TState, TActions>,
	options?: {
		displayName?: string;
		selector?: Selector<TState, TSubscriberProps, TSelectedState> | null;
	},
): SubscriberComponent<TSelectedState, BoundActions<TState, TActions>, TSubscriberProps>;

export function createSubscriber<
	TState,
	// oxlint-disable-next-line no-unused-vars
	TActions extends Record<string, ActionThunk<TState, TActions>>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
>(Store: any, { selector, displayName = '' }: any = {}): any {
	const useStore = createHook(Store, { selector });
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	const Subscriber = function Subscriber({ children, ...rest }: any) {
		const api = useStore(hasAdditionalProps(rest) ? rest : undefined);
		return children(...api);
	};
	Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
	return Subscriber;
}
